import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector, inject } from '@angular/core';

import { OverlayFactory } from '@frontend/vanilla/shared/overlay-factory';

import { BetstationLoginCardPinComponent } from './betstation-login-card-pin';
import { CARD_NUMBER } from './betstation-login.models';

@Injectable({ providedIn: 'root' })
export class BetstationLoginOverlayService {
    private injector = inject(Injector);
    private overlay = inject(OverlayFactory);

    private currentRef: OverlayRef | null;

    show(cardNumber: string) {
        if (this.currentRef) {
            return;
        }

        const overlayRef = this.overlay.create({
            panelClass: ['generic-modal-overlay'],
        });

        overlayRef.detachments().subscribe(() => {
            this.overlay.dispose(overlayRef);
            this.currentRef = null;
        });

        const portal = new ComponentPortal(BetstationLoginCardPinComponent, null, this.createInjector(overlayRef, cardNumber));

        overlayRef.attach(portal);
        this.currentRef = overlayRef;
    }

    private createInjector(overlayRef: OverlayRef, cardNumber: string) {
        return Injector.create({
            providers: [
                { provide: OverlayRef, useValue: overlayRef },
                { provide: CARD_NUMBER, useValue: cardNumber },
            ],
            parent: this.injector,
        });
    }
}
